<template>
  <InputComponent :label="$t('selectx', { x: $tc('floorplan').toLowerCase() })" class="shop-floorplan-image-selector">
    <template #default>
      <Card
        v-for="(item, index) in items"
        :key="index"
        class="shop-floorplan-image-selector__item"
        :class="{ 'shop-floorplan-image-selector__item--selected': isSelected(item) }"
        theme="border"
        @click="$emit('input', item)"
      >
        <div class="shop-floorplan-image-selector__item-image" :style="{ backgroundImage: `url(${item.url})` }"></div>
        <input type="text" v-model="item.name" class="shop-floorplan-image-selector__item-title" />
      </Card>
      <Card class="shop-floorplan-image-selector__item shop-floorplan-image-selector__item--placeholder" theme="border">
        <Loader :value="promise" theme="default">
          <FontAwesomeIcon :icon="['fal', 'plus']" size="4x" />
          <div class="shop-floorplan-image-selector__item-title">{{ $t('add') }}</div>
          <input type="file" ref="input" accept="image/*" @change="onChange" />
        </Loader>
      </Card>
    </template>
  </InputComponent>
</template>

<script>
import { VueComponentUpload as upload } from '@kvass/storage'

import Card from '@/components/Card'
import { InputComponent } from 'vue-elder-input'

export default {
  props: {
    value: Object,
    items: Array,
  },
  data() {
    return {
      promise: null,
    }
  },
  methods: {
    isSelected(item) {
      return this.value && item.url === this.value.url
    },
    async onChange(e) {
      if (!e.target.files.length) return
      this.promise = upload(e.target.files[0], () => {}, { compression: 'default' })
      this.$emit('input', await this.promise)
      this.$refs.input.value = null
    },
  },
  components: {
    Card,
    InputComponent,
  },
}
</script>

<style lang="scss">
.shop-floorplan-image-selector {
  .elder-input__label {
    margin-bottom: 1rem;
  }

  .elder-input__value {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));

    grid-gap: $form-gap;
  }

  .elder-input__field {
    border: none;
    background-color: transparent;
  }

  &__item {
    transition: border-color 150ms ease-out;
    cursor: pointer;

    .card__content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
    }

    &--selected {
      border-color: var(--primary) !important;
      background-color: css-alpha('primary', 0.05);
      font-weight: bold;
      color: var(--primary);
    }

    &:hover {
      border-color: css-darken('border-color', 10%);
    }

    &--placeholder {
      position: relative;
      cursor: pointer;
      background-color: css-lighten('border-color', 8%);

      input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
      }

      .elder-loader {
        margin: auto;
        flex-grow: initial;
      }
    }

    img {
      max-width: 150px;
      margin: auto;
    }

    svg {
      opacity: 0.2;
      display: block;
    }

    &-title {
      margin-top: auto;
      width: 100%;
      outline: none;
      text-align: center;
    }

    &-image {
      width: 100%;
      min-height: 150px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      margin-bottom: 1rem;
    }
  }
}
</style>
